import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "-search-sticky",
  "data-scroll": "",
  "data-scroll-repeat": ""
}
const _hoisted_2 = { class: "c-programmes-search u-bg-color-6 -search-margin-top" }
const _hoisted_3 = { class: "o-container" }
const _hoisted_4 = { class: "o-form" }
const _hoisted_5 = { class: "o-form__item__container" }
const _hoisted_6 = { class: "o-form__item" }
const _hoisted_7 = {
  class: "o-label sr-only",
  for: "programmes-search"
}
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-search",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "search"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#search" })
], -1 /* HOISTED */)
const _hoisted_10 = {
  key: 0,
  class: "o-form__item"
}
const _hoisted_11 = {
  class: "o-label sr-only",
  for: "year"
}
const _hoisted_12 = { value: "" }
const _hoisted_13 = ["value"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_15 = {
  key: 1,
  class: "o-form__item"
}
const _hoisted_16 = {
  class: "o-label sr-only",
  for: "target"
}
const _hoisted_17 = { value: "" }
const _hoisted_18 = ["value"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_20 = {
  key: 2,
  class: "o-form__item"
}
const _hoisted_21 = {
  class: "o-label sr-only",
  for: "theme"
}
const _hoisted_22 = { value: "" }
const _hoisted_23 = ["value"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_25 = {
  key: 3,
  class: "o-form__item"
}
const _hoisted_26 = {
  class: "o-label sr-only",
  for: "theme"
}
const _hoisted_27 = { value: "" }
const _hoisted_28 = ["value"]
const _hoisted_29 = ["value"]
const _hoisted_30 = ["value"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_32 = {
  key: 4,
  class: "o-form__item"
}
const _hoisted_33 = {
  class: "o-label sr-only",
  for: "format"
}
const _hoisted_34 = { value: "" }
const _hoisted_35 = ["value"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_37 = { class: "o-form__button c-tooltip__wrap" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "o-button__icos" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "o-button__ico" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "o-ico -ico-search-category",
      role: "img"
    }, [
      /*#__PURE__*/_createElementVNode("title", null, "search-category"),
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#search-category" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "o-button__ico" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "o-ico -ico-search-category",
      role: "img"
    }, [
      /*#__PURE__*/_createElementVNode("title", null, "search-category"),
      /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#search-category" })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_39 = {
  key: 0,
  class: "o-button__text"
}
const _hoisted_40 = { class: "o-button__text__elm" }
const _hoisted_41 = { class: "sr-only" }
const _hoisted_42 = {
  key: 1,
  class: "o-button__text"
}
const _hoisted_43 = { class: "o-button__text__elm" }
const _hoisted_44 = { class: "sr-only" }
const _hoisted_45 = { class: "c-tooltip" }
const _hoisted_46 = {
  key: 0,
  class: "c-tooltip__text"
}
const _hoisted_47 = {
  key: 1,
  class: "c-tooltip__text"
}
const _hoisted_48 = {
  key: 0,
  class: "c-programmes-search__filters"
}
const _hoisted_49 = { class: "o-container" }
const _hoisted_50 = { class: "c-programmes-search__filters__wrap" }
const _hoisted_51 = {
  key: 0,
  class: "c-programmes-search__filters__total"
}
const _hoisted_52 = { class: "c-programmes-search__filters__actives" }
const _hoisted_53 = { class: "c-programmes-search__filters__actives__item" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */)
const _hoisted_57 = { class: "sr-only" }
const _hoisted_58 = {
  key: 1,
  class: "c-programmes-search__filters__reset"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "c-loader" }, null, -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, _toDisplayString($options.t("Mots clés")), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  onKeyup: [
                    _cache[0] || (_cache[0] = $event => ($options.keyupSearch())),
                    _cache[1] || (_cache[1] = _withKeys($event => ($options.refreshUrlQuery()), ["enter"]))
                  ],
                  class: "o-input",
                  id: "programmes-search",
                  type: "text",
                  placeholder: $options.t('Mots clés'),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.searchInput) = $event))
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_8), [
                  [_vModelText, $data.searchInput]
                ]),
                _hoisted_9
              ]),
              ($data.years.length>0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("label", _hoisted_11, _toDisplayString($options.t("Année")), 1 /* TEXT */),
                    _withDirectives(_createElementVNode("select", {
                      onChange: _cache[3] || (_cache[3] = $event => ($options.changeSelectionYear())),
                      class: "o-select",
                      id: "year",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.selectedYear) = $event))
                    }, [
                      _createElementVNode("option", _hoisted_12, _toDisplayString($options.t("Année")), 1 /* TEXT */),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.years, (year) => {
                        return (_openBlock(), _createElementBlock("option", { value: year }, _toDisplayString(year), 9 /* TEXT, PROPS */, _hoisted_13))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelSelect, $data.selectedYear]
                    ]),
                    _hoisted_14
                  ]))
                : _createCommentVNode("v-if", true),
              ($data.jesuis.length>0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString($options.t("Je suis")), 1 /* TEXT */),
                    _withDirectives(_createElementVNode("select", {
                      onChange: _cache[5] || (_cache[5] = $event => ($options.changeSelectionTarget())),
                      ref: "target",
                      class: "o-select",
                      id: "target",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($data.selectedJe) = $event))
                    }, [
                      _createElementVNode("option", _hoisted_17, _toDisplayString($options.t("Je suis")), 1 /* TEXT */),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.jesuis, (je) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: je.id
                        }, _toDisplayString(je.title), 9 /* TEXT, PROPS */, _hoisted_18))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelSelect, $data.selectedJe]
                    ]),
                    _hoisted_19
                  ]))
                : _createCommentVNode("v-if", true),
              ($data.enseignants.length>0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("label", _hoisted_21, _toDisplayString($options.t("Corps enseignants")), 1 /* TEXT */),
                    _withDirectives(_createElementVNode("select", {
                      onChange: _cache[7] || (_cache[7] = $event => ($options.changeSelectionEnseignant())),
                      ref: "theme",
                      class: "o-select",
                      id: "theme",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($data.selectedEnseignant) = $event))
                    }, [
                      _createElementVNode("option", _hoisted_22, _toDisplayString($options.t("Corps enseignants")), 1 /* TEXT */),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.enseignants, (enseignant) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: enseignant.id
                        }, _toDisplayString(enseignant.title), 9 /* TEXT, PROPS */, _hoisted_23))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelSelect, $data.selectedEnseignant]
                    ]),
                    _hoisted_24
                  ]))
                : _createCommentVNode("v-if", true),
              ($data.categories.length>0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("label", _hoisted_26, _toDisplayString($options.t("Thématiques")), 1 /* TEXT */),
                    _withDirectives(_createElementVNode("select", {
                      onChange: _cache[9] || (_cache[9] = $event => ($options.changeSelectionCategory())),
                      ref: "theme",
                      class: "o-select",
                      id: "theme",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($data.selectedCategory) = $event))
                    }, [
                      _createElementVNode("option", _hoisted_27, _toDisplayString($options.t("Thématiques")), 1 /* TEXT */),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.categories, (category) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (category.parent === null)
                            ? (_openBlock(), _createElementBlock("option", {
                                key: 0,
                                value: category.id
                              }, _toDisplayString(category.title), 9 /* TEXT, PROPS */, _hoisted_28))
                            : _createCommentVNode("v-if", true),
                          (category.parent === null && $options.hasChilds(category))
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($data.categories, (child) => {
                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                  (child.parent === category.id)
                                    ? (_openBlock(), _createElementBlock("option", {
                                        key: 0,
                                        value: child.id
                                      }, "— " + _toDisplayString(child.title), 9 /* TEXT, PROPS */, _hoisted_29))
                                    : _createCommentVNode("v-if", true),
                                  (child.parent === category.id && $options.hasChilds(child))
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($data.categories, (children) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                                          (children.parent === child.id)
                                            ? (_openBlock(), _createElementBlock("option", {
                                                key: 0,
                                                value: children.id
                                              }, "—— " + _toDisplayString(children.title), 9 /* TEXT, PROPS */, _hoisted_30))
                                            : _createCommentVNode("v-if", true)
                                        ], 64 /* STABLE_FRAGMENT */))
                                      }), 256 /* UNKEYED_FRAGMENT */))
                                    : _createCommentVNode("v-if", true)
                                ], 64 /* STABLE_FRAGMENT */))
                              }), 256 /* UNKEYED_FRAGMENT */))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelSelect, $data.selectedCategory]
                    ]),
                    _hoisted_31
                  ]))
                : _createCommentVNode("v-if", true),
              ($data.formats.length>0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createElementVNode("label", _hoisted_33, _toDisplayString($options.t("Formats")), 1 /* TEXT */),
                    _withDirectives(_createElementVNode("select", {
                      onChange: _cache[11] || (_cache[11] = $event => ($options.changeSelectionFormat())),
                      ref: "format",
                      class: "o-select",
                      id: "format",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (($data.selectedFormat) = $event))
                    }, [
                      _createElementVNode("option", _hoisted_34, _toDisplayString($options.t("Formats")), 1 /* TEXT */),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.formats, (format) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: format.id
                        }, _toDisplayString(format.title), 9 /* TEXT, PROPS */, _hoisted_35))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                      [_vModelSelect, $data.selectedFormat]
                    ]),
                    _hoisted_36
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("button", {
                  class: "o-button -button-bg js-advanced-search-button",
                  onClick: _cache[13] || (_cache[13] = _withModifiers((...args) => ($options.toggleAdvancedSearch && $options.toggleAdvancedSearch(...args)), ["prevent"])),
                  "aria-label": "Ouvrir et/ou fermer la recherche"
                }, [
                  _hoisted_38,
                  ($props.target===null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                        _createElementVNode("span", _hoisted_40, [
                          _createTextVNode(_toDisplayString($options.t("Recherche avancée")) + " ", 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_41, _toDisplayString($options.t("pour trouver un article")), 1 /* TEXT */)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_42, [
                        _createElementVNode("span", _hoisted_43, [
                          _createTextVNode(_toDisplayString($options.t("Rechercher")) + " ", 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_44, _toDisplayString($options.t("pour trouver un article")), 1 /* TEXT */)
                        ])
                      ]))
                ]),
                _createElementVNode("div", _hoisted_45, [
                  ($props.target===null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString($options.t("Voir les")) + " " + _toDisplayString($data.results) + " " + _toDisplayString($options.t("résultats")), 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString($options.t("Voir les")) + " " + _toDisplayString($options.t("résultats")), 1 /* TEXT */))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    ($options.tags.length>0 || $data.searchInput.length>0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              ($props.target===null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    _createElementVNode("span", null, _toDisplayString($data.results) + " " + _toDisplayString($options.t("résultats")), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_52, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.tags, (tag) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _createElementVNode("span", null, _toDisplayString(tag.title), 1 /* TEXT */),
                    _createElementVNode("button", {
                      class: "c-programmes-search__filters__remove",
                      onClick: _withModifiers($event => ($options.removeTag(tag)), ["prevent"])
                    }, [
                      _hoisted_55,
                      _hoisted_56,
                      _createElementVNode("span", _hoisted_57, _toDisplayString($options.t("Retirer le filtre")) + " : " + _toDisplayString(tag.title), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_54)
                  ]))
                }), 256 /* UNKEYED_FRAGMENT */))
              ]),
              ($options.tags.length>0 || $data.searchInput.length>0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                    _createElementVNode("button", {
                      class: "o-button -button-reset",
                      onClick: _cache[14] || (_cache[14] = _withModifiers((...args) => ($options.resetSearch && $options.resetSearch(...args)), ["prevent"]))
                    }, _toDisplayString($options.t("Réinitialiser la recherche")), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _hoisted_59
  ], 64 /* STABLE_FRAGMENT */))
}